module.exports = __webpack_public_path__ + "img/tanyuan.c2e10b31.jpg";